module.exports = __webpack_public_path__ + "static/media/trees.4bcee2ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Main/assets/trees.png
// module id = 555
// module chunks = 0